import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation16({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)
  const [drops, setDrops] = useState<number[]>([])

  useEffect(() => {
    // Créer des gouttes
    const dropCount = 8
    for (let i = 0; i < dropCount; i++) {
      setTimeout(() => {
        setDrops(prev => [...prev, i])
      }, i * 150)
    }

    setTimeout(() => setShowBadge(true), 1500)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes cascadeDrop {
          0% {
            transform: translateY(-200px) scale(0) rotate(-20deg);
            opacity: 0;
          }
          30% {
            opacity: 1;
            transform: translateY(0) scale(1.2) rotate(10deg);
          }
          50% {
            transform: translateY(-30px) scale(1) rotate(-5deg);
          }
          70% {
            transform: translateY(0) scale(1.1) rotate(2deg);
          }
          100% {
            transform: translateY(0) scale(1) rotate(0deg);
            opacity: 1;
          }
        }
        .cascade-drop {
          animation: cascadeDrop 1s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative">
        {/* Étoiles qui tombent */}
        <div className="absolute inset-x-0 top-10 flex justify-center gap-4 pointer-events-none">
          {drops.map((index) => (
            <div
              key={index}
              className="cascade-drop text-4xl"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              ⭐
            </div>
          ))}
        </div>

        {/* Badge central */}
        <div className={`relative z-10 transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          <div className="w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50">
            <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-500 delay-500 ${showBadge ? 'opacity-100' : 'opacity-0'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
